import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import useAuth from '../hooks/useAuth';
import { PATH_AUTH } from '../routes/paths';

type AuthGuardProps = {
  children?: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isInitialized } = useAuth();
  const { pathname, search } = useLocation();

  if (!isInitialized) {
    return null;
  }

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(pathname + search);
    return <Navigate to={`${PATH_AUTH.login}?redirect=${redirect}`} replace />;
  }

  return <>{children}</>;
}
